<template>
  <div>
    <div class="main_banner">
      <b-container fluid>
        <b-row>
          <b-col cols="12" lg="7" md="7" sm="12">
            <div class="left_section">
              <h1>
                Answers to Frequently
                <br />Asked Questions
              </h1>
              <p>
                Although the Robocash service tries to make the loan process as simple
                as possible, you may have some questions. We offer you the answers to
                the most frequent ones.
              </p>
            </div>
          </b-col>
          <b-col cols="12" lg="5" md="5" sm="12">
            <div class="right_section"></div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="news_cont">
      <b-container fluid>
        <b-row>
          <b-col cols="12" lg="4" md="12" sm="12">
            <div class="right_side">
             <nav-list />
              <estimator />
            </div>
          </b-col>
          <b-col cols="12" lg="8" md="12" sm="12">
            <div class="left_side">
                <h3 class="mb-5">About Us</h3>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
                <b-img class="mx-auto d-block mt-5" :src="require('@/assets/images/logo.png')"></b-img>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import estimator from "@/components/estimator.vue";
import navList from "@/views/faqs/navlist.vue"

export default {
  components: {
    estimator,
    navList
  },
  data() {
    return {
      text: `Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
          richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
          brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
          tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
          assumenda shoreditch et. Nihil a`
    };
  }
};
</script>

<style>
.loan_form .estimator_signin {
  margin-top: 75px;
}
</style>
<style lang="scss" scoped>
.main_banner {
  width: 100%;
  background: url("../../assets/images/faqs/banner_faq.jpg");
  background-position: center;
  background-size: cover;
  position: relative;
  padding: 60px 0;
  h1 {
    color: #fff;
    font-weight: 600;
  }
  p {
    color: #fff;
    margin-top: 20px;
  }
  .left_section {
    padding-left: 50px;
  }
}
.news_cont {
  padding: 80px 0 120px;
  .left_side {
    padding-left: 30px;
    .card {
      border: 0;
      background: none;
      header {
        background: #f4f4f4;
        border-radius: 4px 4px 0 0;
        border: 0;
        button {
          background-color: transparent;
          color: #434343;
          border: 0;
          text-align: left;
          text-indent: 30px;
        }
        button:before {
          background: url(../../assets/images/icons/arrow.png) no-repeat;
          background-size: contain;
          opacity: 0.9;
          content: "";
          display: block;
          width: 13px;
          height: 13px;
          position: absolute;
          top: 14px;
          transition: all 0.5s;
        }
        button.not-collapsed::before {
          transform: rotate(90deg);
        }
        button:active,
        button:focus,
        button:active:focus {
          background: none;
          box-shadow: none;
          border: 0;
          outline: 0;
          color: inherit;
        }
      }
      .card-body {
        background: $base-bgcolor-lightblue;
        border-radius: 4px;
      }
    }
  }
}
@media (max-width: 992px) {
  .news_cont {
    .left_side {
      padding-left: 0;
      margin-top: 30px;
    }
  }
}

@media (max-width: 768px) {
  .main_banner {
    background: url("../../assets/images/banner-blue.jpg");
    .left_section {
      padding-left: 0;
    }
  }
}
@media (max-width: 720px) {
  .news_cont .left_side .card {
    flex-direction: column !important;
  }
}
</style>